import { ChevronLeft, ChevronRight, PhoneCall } from "lucide-react";
import React, { useRef, useState, useEffect } from "react";
import floorPlanDummyImg from '../../Assets/images/Floor-plan-real-estate.png'
import EnquiryFormModal from "../../Components/Forms/EnquiryFormModal";

const FloorPlanPrice = ({ data }) => {
    const [open, setOpen] = useState(false);
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(false);
    const scrollRef = useRef(null);
    const [activeTab, setActiveTab] = useState(0);
    const url = process.env.REACT_APP_LINK

    const scrollCarousel = (direction) => {
        const container = scrollRef.current;
        const scrollAmount = 300;
        if (container) {
            container.scrollBy({
                left: direction === "left" ? -scrollAmount : scrollAmount,
                behavior: "smooth",
            });
        }
    };

    const checkScroll = () => {
        const container = scrollRef.current;
        if (container) {
            setShowLeft(container.scrollLeft > 0);
            setShowRight(container.scrollLeft + container.clientWidth < container.scrollWidth);
        }
    };

    useEffect(() => {
        checkScroll();
        const container = scrollRef.current;
        if (container) {
            container.addEventListener("scroll", checkScroll);
            window.addEventListener("resize", checkScroll);
        }

        return () => {
            if (container) container.removeEventListener("scroll", checkScroll);
            window.removeEventListener("resize", checkScroll);
        };
    }, [activeTab]);



    // Filter out flatTypes with no builtUpAreas or missing expectedPrice
    const validFlatTypes = (data?.flatType || []).filter(
        (flat) =>
            Array.isArray(flat.builtUpAreas) &&
            flat.builtUpAreas.length > 0 &&
            flat.builtUpAreas[0]?.expectedPrice
    );

    const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num) || num <= 0) return 'N/A';

        if (num >= 1e7) {
            return `${(num / 1e7).toFixed(2)} Crore`;
        } else if (num >= 1e5) {
            return `${(num / 1e5).toFixed(2)} Lakh`;
        } else {
            return num.toLocaleString('en-IN'); // fallback for values < 1 Lakh
        }
    };

    if (!validFlatTypes.length) return null;

    const currentFlat = validFlatTypes[activeTab];

    return (
        <>
            <div className="detail-page-main-section-container-sp">
                <div className="detail-page-main-section-heading-sp">
                    <h2>Floor Plans & Pricing</h2>
                </div>

                {/* Tabs */}
                <div className="detail-page-tabs-section-sp">
                    {validFlatTypes.map((flat, idx) => (
                        <span
                            key={idx}
                            className={`tab-item-sp ${activeTab === idx ? "active-tab-sp" : ""}`}
                            onClick={() => setActiveTab(idx)}
                        >
                            {flat?.type || `Type ${idx + 1}`}
                        </span>
                    ))}
                </div>

                <div className="sarfare-floor-plan-carousel-wrapper">
                    {showLeft && (
                        <button className="sarfare-floor-plan-carousel-btn left" onClick={() => scrollCarousel('left')}>
                            <ChevronLeft />
                        </button>
                    )}

                    <div className="sarfare-floor-plan-carousel-container" ref={scrollRef}>

                        {currentFlat?.builtUpAreas.map((areaObj, idx) => (
                            <div key={idx} className="detail-page-card-sp">
                                <div className="area-row">
                                    {(() => {

                                        const raw = areaObj.value;

                                        // Extract numeric part safely
                                        const num = parseFloat(
                                            String(raw ?? "").replace(/[^\d.]/g, "")
                                        );

                                        const hasValidNumber = !isNaN(num) && num > 0;

                                        return (
                                            <>
                                                <h3>
                                                    {hasValidNumber ? `${num} sqft` : "N/A"}
                                                    {hasValidNumber && (
                                                        <> ({(num * 0.092903).toFixed(2)} m²)</>
                                                    )}
                                                </h3>
                                                <p>Carpet area</p>
                                            </>
                                        );
                                    })()}
                                </div>


                                <div className="floor-plan-image">
                                    <img
                                        src={
                                            currentFlat.floorPlan
                                                ? `${url}/Images/Store/${currentFlat.floorPlan}`
                                                : floorPlanDummyImg
                                        }
                                        alt={`${currentFlat.type} Image`}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = floorPlanDummyImg;
                                        }}
                                    />
                                </div>

                                <div className="expected-price">
                                    <h4>₹ {formatPrice(areaObj.expectedPrice)}</h4>
                                </div>

                                <div className="floor-plan-status-sp">
                                    <p>{data?.availability || "Not Available"}</p>
                                </div>

                                <div className="detail-page-floor-footer-sp">
                                    <button className="request-callback-btn" onClick={() => setOpen(true)}>
                                        <PhoneCall style={{ marginRight: 5 }} size={14} /> Request Callback
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {showRight && (
                        <button className="sarfare-floor-plan-carousel-btn right" onClick={() => scrollCarousel('right')}>
                            <ChevronRight />
                        </button>
                    )}
                </div>


            </div>

            <EnquiryFormModal isOpen={open} onClose={() => setOpen(false)} source="Property Detail Page" user_id="HBTR0003" />
        </>
    );
};

export default FloorPlanPrice;
